import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsIssueCardComponent } from './reports-issue-card.component';
import { CtButtonModule, CtControlModule } from '@ctsolution/ct-framework';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    CtControlModule,
    CtButtonModule,
    MatIconModule
  ],
  declarations: [ReportsIssueCardComponent],
  exports: [ReportsIssueCardComponent]
})
export class ReportsIssueCardModule { }
